export default {
    path: '/scan-error',
    components: {
        default: () => import(/* webpackChunkName: "ScanError" */ '../pages/ScanError.vue')
    }
}